<ng-container *transloco="let t">
  <authority-labs-entity-selector
    [title]="title"
    [crudService]="service"
    [searchFields]="searchFields"
    [optionTpl]="optionTpl"
    [selectedTpl]="selectedTpl"
    [getLabel]="getLabel"
    [optionHeight]="62"
    [optionsSize]="4"
    [entityDialogService]="plannerDialogService"
    [canAdd]="true"
  >
    <ng-template let-entity="entity" #optionTpl>
      <authority-labs-planner-info
        [planner]="entity"
      ></authority-labs-planner-info>
    </ng-template>
    <ng-template let-entity="entity" #selectedTpl>
      <authority-labs-planner-info
        [planner]="entity"
      ></authority-labs-planner-info>
    </ng-template>
  </authority-labs-entity-selector>
</ng-container>
